import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../context/CookieConsentContext';
import { firstPartyStorage, gatedEmbeds, outboundLinks, notUsed } from '../data/site-inventory';

const Table = ({ headers, children }) => (
  <div className="overflow-x-auto mb-10">
    <table className="w-full text-left text-14 border-collapse">
      <thead>
        <tr className="border-b border-black/20">
          {headers.map((h) => (
            <th key={h} className="py-2 pr-4 font-medium">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="font-light text-customGray">{children}</tbody>
    </table>
  </div>
);

const CookiePolicy = () => {
  const { t } = useTranslation();
  const { openSettings } = useCookieConsent();

  return (
    <div className="grid grid-cols-10 pb-28">
      <div className="col-start-2 col-span-8 mt-14">
        <h1 className="text-45 mb-4">{t('cookie.policy.title')}</h1>
        <p className="text-16 font-light text-customGray mb-6 whitespace-pre-line">{t('cookie.policy.intro')}</p>
        <button
          type="button"
          onClick={openSettings}
          className="border border-black/40 px-8 py-2.5 text-16 font-light mb-14 hover:bg-[#242424] hover:text-white duration-200"
        >
          {t('footer.cookieSettings')}
        </button>

        <h2 className="text-24 font-medium mb-3">{t('cookie.policy.table1Title')}</h2>
        <p className="text-16 font-light text-customGray mb-4">{t('cookie.policy.table1Text')}</p>
        <Table headers={[t('cookie.policy.col.name'), t('cookie.policy.col.type'), t('cookie.policy.col.category'), t('cookie.policy.col.duration'), t('cookie.policy.col.purpose'), t('cookie.policy.col.transfer')]}>
          {firstPartyStorage.map((item) => (
            <tr key={item.name} className="border-b border-black/10 align-top">
              <td className="py-3 pr-4">{item.name}</td>
              <td className="py-3 pr-4">{item.type}</td>
              <td className="py-3 pr-4">{t(`cookie.categories.${item.category}.title`)}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.duration.${item.durationKey}`)}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.purpose.${item.purposeKey}`)}</td>
              <td className="py-3 pr-4">{t('cookie.policy.no')}</td>
            </tr>
          ))}
        </Table>

        <h2 className="text-24 font-medium mb-3">{t('cookie.policy.table2Title')}</h2>
        <p className="text-16 font-light text-customGray mb-4">{t('cookie.policy.table2Text')}</p>
        <Table headers={[t('cookie.policy.col.name'), t('cookie.policy.col.page'), t('cookie.policy.col.category'), t('cookie.policy.col.party'), t('cookie.policy.col.purpose'), t('cookie.policy.col.transfer')]}>
          {gatedEmbeds.map((item) => (
            <tr key={item.name} className="border-b border-black/10 align-top">
              <td className="py-3 pr-4">{item.name}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.pages.${item.purposeKey}`)}</td>
              <td className="py-3 pr-4">{t(`cookie.categories.${item.category}.title`)}</td>
              <td className="py-3 pr-4">{item.party}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.purpose.${item.purposeKey}`)}</td>
              <td className="py-3 pr-4">{t('cookie.policy.yesUS')}</td>
            </tr>
          ))}
        </Table>

        <h2 className="text-24 font-medium mb-3">{t('cookie.policy.table3Title')}</h2>
        <p className="text-16 font-light text-customGray mb-4">{t('cookie.policy.table3Text')}</p>
        <Table headers={[t('cookie.policy.col.name'), t('cookie.policy.col.page'), t('cookie.policy.col.url'), t('cookie.policy.col.party'), t('cookie.policy.col.purpose')]}>
          {outboundLinks.map((item) => (
            <tr key={item.name} className="border-b border-black/10 align-top">
              <td className="py-3 pr-4">{item.name}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.pages.${item.purposeKey}`)}</td>
              <td className="py-3 pr-4 break-all">{item.url}</td>
              <td className="py-3 pr-4">{item.party}</td>
              <td className="py-3 pr-4">{t(`cookie.policy.purpose.${item.purposeKey}`)}</td>
            </tr>
          ))}
        </Table>

        <h2 className="text-24 font-medium mb-3">{t('cookie.policy.notUsedTitle')}</h2>
        <ul className="list-disc pl-5 text-16 font-light text-customGray space-y-1 mb-12">
          {notUsed.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        {['q2', 'q3', 'q4', 'q5', 'q6', 'q7'].map((key) => (
          <section key={key} className="mb-10">
            <h2 className="text-24 font-medium mb-3">{t(`cookie.policy.${key}.title`)}</h2>
            <p className="text-16 font-light text-customGray leading-relaxed whitespace-pre-line">
              {t(`cookie.policy.${key}.text`)}
            </p>
          </section>
        ))}
      </div>
    </div>
  );
};

export default CookiePolicy;
